import { Grid, Typography } from "@mui/material";
import React from "react";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";

export default function BranchVisitDetails({
  selectedFilter,
  SelectedData,

  monthName,
  selectedYear,
}) {
  const columns = [
    {
      field: "enquiry_name",
      headerName: "Enquiry Name",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row.enquiry_id.id}`,
              "_blank"
            )
          }
        >
          {" "}
          {`${
            params?.row?.enquiry_id?.first_name
              ? params?.row?.enquiry_id?.first_name
              : ""
          } ${
            params?.row?.enquiry_id?.last_name
              ? params?.row?.enquiry_id?.last_name
              : ""
          }`}{" "}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      
      minWidth: 150,
      headerAlign: "center",
      align: "center",

    
    },
    {
      field: "branch",
      headerName: "Visited Branch",
      headerAlign: "center",
      align: "center",
      minWidth: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.branch_visited_id?.branch_name || "",
      renderCell: (params) => <div>{params?.row?.branch_visited_id?.branch_name }</div>,
    },
    {
      field: "service",
      headerName: "Service",
      headerAlign: "center",
      align: "center",
      minWidth:200,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.service_id?.service_name || "",
      renderCell: (params) => <div>{params?.row?.service_id?.service_name}</div>,
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      headerAlign: "center",
      align: "center",
      minWidth: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params?.row?.sub_service_id?.name}</div>,
    },
    {
      field: "appointment_date",
      headerName: "Appoinment Date",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      headerClassName: "header-cell",
      
    },
    {
      field: "prospective_leval",
      headerName: "Prospective Leval",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.prospective_level_id?.prospective_level || "",
      renderCell: (params) => <div>{params?.row?.prospective_level_id?.prospective_level}</div>,
    },
    {
      field: "stage",
      headerName: "Stage",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.stage_id?.stage_name || "",
      renderCell: (params) => <div>{params?.row?.stage_id?.stage_name }</div>,
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params?.row?.assign_to?.first_name || ""} ${params?.row?.assign_to?.last_name || ""}`,
      renderCell: (params) => <div>{`${params?.row?.assign_to?.first_name || ""} ${params?.row?.assign_to?.last_name || ""}`}</div>,
    },

   
    {
      field: "walk_in_status",
      headerName: "Walkin Status",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      headerClassName: "header-cell",
     
    },
  ];
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {selectedFilter === "default" && (
            <Typography variant="h4" textAlign="center">
              {monthName} {selectedYear}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={SelectedData}
            columns={columns}
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Grid>
      </Grid>
    </>
  );
}
